import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from 'mobx-react';
import { alertStore } from '@/alert/stores/AlertStore';
import { analyticsStore } from '@/analytics/store/AnalyticsStore';
import { billingStore } from '@/billing/stores/BillingStore';
import { collectionsStore } from '@/collection/stores/CollectionsStore';
import { appStore } from '@/common/stores/AppStore';
import { configurationStore } from '@/common/stores/ConfigurationStore';
import { globalSearchConfigStore } from '@/common/stores/GlobalSearchConfigStore';
import { presentationStore } from '@/common/stores/PresentationStore';
import { referenceStore } from '@/common/stores/ReferenceStore';
import separateWindowStore from '@/common/stores/SeparateWindowStore';
import uploadFileStore from '@/common/stores/UploadFileStore';
import { comparisonStore } from '@/comparison/stores/ComparisonStore';
import { contactsStore } from '@/contacts/stores/ContactsStore';
import { servicesStore } from '@/conversion/stores/ServicesStore';
import { driveCollectionsStore } from '@/drive/stores/DriveCollectionsStore';
import { driveModifierStore } from '@/drive/stores/DriveModifierStore';
import { pinnedItemsStore } from '@/forwarding/stores/PinnedItemsStore';
import { netBoxStore } from '@/netbox/stores/NetBoxStore';
import { pendingSpectrumTasksStore } from '@/spectrum/stores/PendingSpectrumTasksStore';
import { userStore } from '@/user/stores/UserStore';
const store = {
    alertStore,
    billingStore,
    configurationStore,
    appStore,
    userStore,
    comparisonStore,
    collectionsStore,
    analyticsStore,
    netBoxStore,
    referenceStore,
    presentationStore,
    separateWindowStore,
    contactsStore,
    servicesStore,
    uploadFileStore,
    globalSearchConfigStore,
    pinnedItemsStore,
    driveCollectionsStore,
    driveModifierStore,
    pendingSpectrumTasksStore,
};
export function StoreProvider({ children }) {
    return _jsx(Provider, { ...store, children: children });
}
export default store;
